import { isSameArrays } from "../helper/OGcomplianceValidateExcel";

import { DUPLICATE_DATA, DUPLICATE_DATA_2, EMPTY_VALUE, EMPTY_VALUE_1, EMPTY_VALUE_2, EXCEL_EMPTY_ERR_MSG, EXCEL_Template, HEADER_ERR, HEADER_ERR_MESSAGE, INVALID_CHAR_2 } from "../components/OutletGeoCompliance/OGComplianceBulkUpload/BulkUpdateModal.constant";
import { findFirstDuplicateRow, validateField, validateFileMeta } from "./FileHelper";
import { validateSpecialChar } from "./PJPValidateExcel";
import { DUPLICATE_OUTLET_MAPPING } from "../components/MerchandisingSets/MerchandizingSetUpload/MSUploadModal.constant";

export const getEmptyValues = ({ row, setFileError, resolve }) => {
    if (!row["POSM ID"] || !row["Outlet ID"] || !row["Allocated quantity"]) {
        let error = `${EMPTY_VALUE_1} ${row.__rowNum__ + 1}${EMPTY_VALUE_2}`;
        setFileError({ header: EMPTY_VALUE, message: error });
        resolve("invalid");
        return true;
    }
    return false;
};

export const validateOtherFields = ({ filtered, setFileError, resolve }) => {
    for (const row of filtered) {
        const isSpecialChars = validateSpecialChar({ row, setFileError, resolve, excludeCols: ["Allocated quantity"] });
        const isEmpty = getEmptyValues({ row, setFileError, resolve });
        const isAllocatedQtyValid = validateField({
            row,
            field: "Allocated quantity",
            setFileError,
            resolve,
            validateFn: (v) => v && Number(v) > 0 && /^\d+$/.test(Number(v)),
            errorHeader: "Invalid Allocated quantity",
            errorMessageFn: (r) =>
                `Allocated quantity in row ${r.__rowNum__ + 1} is invalid${INVALID_CHAR_2}`
        });
        
        if (isEmpty || isSpecialChars || !isAllocatedQtyValid) return true;
    }
    return false;
};

const checkDuplicateValues = ({ filtered, setFileError, resolve }) => {
    const duplicate = findFirstDuplicateRow(filtered, ["POSM ID", "Outlet ID"]);
    if (duplicate) {
        let error = `${DUPLICATE_OUTLET_MAPPING}${duplicate.__rowNum__ + 1}${DUPLICATE_DATA_2}`;
    setFileError({ header: DUPLICATE_DATA, message: error });
    resolve("invalid");
    return true;
  }
  return validateOtherFields({ filtered, setFileError, resolve });
}
export const getPosmOutletValidation = ({ filtered, setFileError, resolve }) => {
    if (!filtered.length) {
        setFileError({ header: EXCEL_Template, message: EXCEL_EMPTY_ERR_MSG });
        resolve("invalid");
        return true;
    }
    return checkDuplicateValues({ filtered, setFileError, resolve });
};

export const getFormattedRouteData = (data) => {
    const normalizedData = data.replace(/\r\n|\r/g, '\n');
    const excelData = normalizedData.split('\n');

    let formattedData = excelData
        .map((row, index) => {
            const rowData = row.split(",");
            const isEmpty = rowData.every((cell) => cell === "");
            if (index !== 0 && !isEmpty) {
                return {
                    "POSM ID": rowData[0],
                    "Outlet ID": rowData[1],
                    "Allocated quantity": rowData[2],
                    __rowNum__: index,
                };
            }
            return null;
        })
        .filter(Boolean);

    return formattedData;
};

const getPosmOutetHeader = (data) => {
    const headerLine = data.split('\n')[0];
    const header = headerLine.split(',').map(h => h.trim());
    if (isSameArrays(header, ["POSM ID", "Outlet ID", "Allocated quantity"])) {
        return header;
    }
    return false;
}

export const ValidateExcel = (file, setFileError) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            if (!validateFileMeta(file, setFileError)) {
                resolve("invalid");
                return;
            }
            const data = reader.result;
            let formattedData = getFormattedRouteData(data);
            const filtered = formattedData.filter((row) =>
                Object.values(row).some((v) => v !== "")
            );

            const routeMasterHeader = getPosmOutetHeader(data);
            if (!routeMasterHeader) {
                setFileError({ header: HEADER_ERR, message: HEADER_ERR_MESSAGE });
                resolve("invalid");
                return;
            }
            getPosmOutletValidation({ filtered, setFileError, resolve });
            resolve("valid");
            
        };
        reader.onerror = (error) => {
            console.log(error);
            reject(error);
        };
        reader.readAsText(file);
    });
};
